import React from 'react';
import { Box, Link, useTheme } from '@mui/material';
import { useBanners } from '@/hooks/useBanners';
import Image from 'next/image';

interface BannerDisplayProps {
  pageType: string;
  className?: string;
}

export const BannerDisplay: React.FC<BannerDisplayProps> = ({ pageType, className }) => {
  const theme = useTheme();
  const banners = useBanners(pageType);

  if (banners.length === 0) {
    return null;
  }

  return (
    <Box 
      className={className} 
      sx={{ 
        mt: 2,
        display: 'flex',
        justifyContent: 'center',
        width: '100%'
      }}
    >
      {banners.map((banner) => (
        <Link
          key={banner.imageKey}
          href={banner.link}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: 'block',
            maxWidth: '600px',
            width: '100%',
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
              opacity: 0.9,
              transform: 'scale(1.01)'
            }
          }}
        >
          <Image
            src={`/images/banners/${banner.imageKey}.png`}
            alt={banner.title}
            width={600}
            height={200}
            style={{
              width: '100%',
              height: 'auto',
              borderRadius: '12px',
              boxShadow: theme.palette.mode === 'dark' 
                ? '0 4px 12px rgba(255, 255, 255, 0.1)'
                : '0 4px 12px rgba(0, 0, 0, 0.1)',
              opacity: theme.palette.mode === 'dark' ? 0.9 : 1
            }}
            sizes="(max-width: 600px) 100vw, 600px"
            priority={true}
          />
        </Link>
      ))}
    </Box>
  );
}; 